var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container list-content"},[_c('ModernTable',{attrs:{"loading":_vm.loading,"columns":_vm.columns,"rows":_vm.rows,"pagination":{
        perPage: 10
      },"sort":{
        by: 'date',
        direction: 1,
        date: true
      }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }